const loopYear = (start, end) => {
    let list = [];
    for ( var i = start; i<= end; i++) {
        list.push({ label: i, value: i});
    }
    return list;
}

export const yearData = loopYear( (new Date()).getFullYear() - 60, (new Date()).getFullYear() - 2);
export const monthData = [
    { label: '1月', value: '01' },
    { label: '2月', value: '02' },
    { label: '3月', value: '03' },
    { label: '4月', value: '04' },
    { label: '5月', value: '05' },
    { label: '6月', value: '06' },
    { label: '7月', value: '07' },
    { label: '8月', value: '08' },
    { label: '9月', value: '09' },
    { label: '10月', value: '10' },
    { label: '11月', value: '11' },
    { label: '12月', value: '12' },
]


/** WEBPACK FOOTER **
 ** ./src/component/studentData/droplistData.js
 **/